module.exports = __webpack_public_path__ + "static/media/YM85_2.70791069.jpg";